module.exports = __webpack_public_path__ + "img/img_shouzhi.b698860f.png";